import { capitalize } from '@gonfalon/strings/capitalize';

import type { VariationType } from '#utils/flags/flagConstants';

import { VARIATION_NOT_FOUND } from './instructionListUtils';
import { VariationValue } from './variationInstructionListItemUtils';

export type RemoveVariationInstructionEntryProps = {
  variationType: VariationType;
  name: string;
  isVariationNotFound?: boolean;
  value: string;
};

export function RemoveVariationInstructionEntry({
  isVariationNotFound,
  value,
  variationType,
  name,
}: RemoveVariationInstructionEntryProps) {
  return (
    <>
      <span className="u-mr-s">
        {name && (
          <>
            <b>{name}</b>{' '}
          </>
        )}
        with value:
      </span>
      {isVariationNotFound ? (
        <code>{capitalize(VARIATION_NOT_FOUND)}</code>
      ) : (
        <VariationValue value={value} variationType={variationType} />
      )}
    </>
  );
}
